import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomFieldInput } from '../custom-field-input.directive';
import { SharedFormModule } from '@shared/modules';
import { QuillModule } from 'ngx-quill';
import { CustomFieldType } from '@shared/models';

@Component({
  selector: 'cwt-custom-field-text-input',
  standalone: true,
  imports: [
    CommonModule,
    SharedFormModule,
    QuillModule
  ],
  templateUrl: './custom-field-text-input.component.html',
  styleUrls: ['./custom-field-text-input.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomFieldTextInputComponent extends CustomFieldInput<string> {
  public CustomFieldType = CustomFieldType;

}
